import Blue from '~/core'
import SwiperJS, { Pagination, Autoplay } from 'swiper'
SwiperJS.use([Pagination, Autoplay])

new Blue({
  name: 'Testimonial Carousel',
  selector: '.testimonial',
  setup(container) {
    const carousel = container.querySelector('.testimonial__carousel')
    const wrapper = container.querySelector('.testimonial__wrapper')
    const slides = [...container.querySelectorAll('.testimonial__slide')]
    const pagination = container.querySelector('.testimonial__pagination')

    const playerPopout = container.querySelector('.testimonial__popout')
    const player = container.querySelector('.testimonial__player')

    const random = Math.ceil(Math.random() * 10000)
    carousel.classList.add('swiper')
    carousel.classList.add('swiper-' + random)
    wrapper.classList.add('swiper-wrapper')
    slides.forEach((slide) => slide.classList.add('swiper-slide'))

    if (slides.length > 1) {
      pagination.classList.add('swiper-pagination')
      pagination.classList.add('swiper-pagination-' + random)
      const swiper = new SwiperJS('.swiper-' + random, {
        loop: true,
        autoplay: {
          delay: 100000,
          disableOnInteraction: false,
        },
        pagination: {
          el: pagination,
          clickable: true,
          renderBullet: (index, className) => {
            return '<div class="testimonial__bullet ' + className + '"></div>'
          },
        },
      })
    }

    const closePlayer = (e) => {
      if (e) {
        let InPlayer = e.target.closest('.testimonial__player')
        if (InPlayer) return
      }
      playerPopout.classList.remove('is-open')
      player.setAttribute('src', '')
    }

    const bindNavEvents = (item, trigger) => {
      if (trigger) {
        this.$addEvents(trigger, 'click.stop.prevent enter.stop.prevent space.stop.prevent', (e) => {
          let src = item.querySelector('.testimonial__play').getAttribute('data-url')
          let alt = item.querySelector('.testimonial__play').getAttribute('data-alt')
          player.setAttribute('src', src)
          player.setAttribute('title', alt)

          let activePlayers = [...container.querySelectorAll('.is-open')]
          activePlayers.forEach((active) => active.classList.remove('is-open'))

          window.setTimeout(() => {
            container.querySelector('.testimonial__popout').classList.add('is-open')
          }, 250)
        })
      }
    }
    slides.forEach((item) => {
      let trigger = item.querySelectorAll('.testimonial__play')
      bindNavEvents(item, trigger)
    })
    this.$addEvents(document, 'click', closePlayer)
  },
})
